/* LAMORE — video: play only while visible, pause + sound controls, gallery modal with captions. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setState(wrap, playing) {
    wrap.classList.toggle('is-paused', !playing);
    var b = wrap.querySelector('[data-lr-video-toggle]');
    if (b) b.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  }
  function play(wrap) {
    var v = wrap.querySelector('video'); if (!v) return;
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play(); if (p && p.catch) p.catch(function () { setState(wrap, false); });
    setState(wrap, true);
  }
  function pause(wrap) { var v = wrap.querySelector('video'); if (v) v.pause(); setState(wrap, false); }

  function initVideos() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-lr-video]:not([data-ready])'));
    if (!wraps.length) return;
    wraps.forEach(function (w) {
      w.setAttribute('data-ready', '1');
      var btn = w.querySelector('[data-lr-video-toggle]');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        w.dataset.user = '1';
        if (w.classList.contains('is-paused')) { delete w.dataset.user; play(w); } else pause(w);
      });
      var snd = w.querySelector('[data-lr-video-sound]');
      if (snd) snd.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = w.querySelector('video'); if (!v) return;
        v.muted = !v.muted;
        snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
        if (!v.muted) { delete w.dataset.user; play(w); }
      });
      if (reduce) setState(w, false);
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var w = e.target;
        if (w.dataset.user) return;
        if (e.isIntersecting && e.intersectionRatio > 0.35) play(w); else pause(w);
      });
    }, { threshold: [0, 0.35, 0.6] });
    wraps.forEach(function (w) { io.observe(w); });
  }

  function initModal() {
    document.querySelectorAll('[data-lr-reels]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var dlg = root.querySelector('[data-lr-modal]');
      var mv = dlg && dlg.querySelector('video');
      if (!dlg || !mv || typeof dlg.showModal !== 'function') return;
      var ccEl = dlg.querySelector('[data-lr-cc]'), cues = [];
      mv.addEventListener('timeupdate', function () {
        if (!ccEl) return;
        var t = mv.currentTime, txt = '';
        for (var i = 0; i < cues.length; i++) { if (t >= cues[i][0] && t < cues[i][1]) { txt = cues[i][2]; break; } }
        if (ccEl.textContent !== txt) ccEl.textContent = txt;
      });
      root.addEventListener('click', function (e) {
        var o = e.target.closest('[data-lr-reel-open]');
        if (!o) return;
        var src = o.querySelector('source');
        var v = o.querySelector('video');
        if (!src) return;
        cues = (o.getAttribute('data-captions') || '').split(/\n/).map(function (l) {
          var m = l.trim().match(/^([\d.]+)\s+([\d.]+)\s+(.+)$/); return m ? [parseFloat(m[1]), parseFloat(m[2]), m[3]] : null;
        }).filter(Boolean);
        if (ccEl) ccEl.textContent = '';
        mv.src = src.src; if (v && v.poster) mv.poster = v.poster;
        dlg.showModal();
        var p = mv.play(); if (p && p.catch) p.catch(function () {});
      });
      function close() { mv.pause(); mv.removeAttribute('src'); mv.load(); if (dlg.open) dlg.close(); }
      dlg.querySelector('[data-lr-modal-close]').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('cancel', function () { mv.pause(); });
    });
  }

  function init() { initVideos(); initModal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
